"use client";

export default function Error({ error, reset }) {
  return (
    <main className="flex justify-center items-center flex-col gap-4 p-20">
      <h1 className="text-3xl ">Something went wrong!</h1>
      <p className="text-2xl font-bold">{error.message}</p>

      <button
        className="rounded-xl inline-block bg-primary-400 text-white px-6 py-3 text-lg uppercase font-semibold hover:bg-primary-400/50 transition-colors cursor-pointer"
        onClick={reset}
      >
        Try again
      </button>
    </main>
  );
}
